import moment from 'jalali-moment';



let initialBody = {
  page: 1,
  pageSize: 20,
  orderByField: "",
  orderByDescending: true,
  getExcel: true,
  searchTerm: "",
  start: "",
  end: "",
  orderId: "",
  designerId: "",
  customerId: "",
  status: 1
}



let addInitialValues = {
  description: "",
  startDate: "",
  endDate: "",
  orderId: "",
  designerId: ""
}
// orderName

const designerHistorylCol = [
  {
    field: "designerName",
    headerName: "نام طراح",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "orderName",
    headerName: "نام سفارش",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "customerName",
    headerName: "نام مشتری",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "orderNumber",
    headerName: "شماره سفارش",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "string_StartDate",
    headerName: "تاریخ شروع",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "string_EndDate",
    headerName: "تاریخ پایان",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "duration",
    headerName: "مدت زمان",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
  ,
  {
    field: "description",
    headerName: "توضیحات",
    sortable: false,
    align: "center",
    flex: 1,
    minWidth: 100,
    menubar: false,
  }
]


let performanceInitialBody = {
  date: moment(),
  orderId: "",
  customerId: ""
}

const timeSlots = [
  { start: "08:00", end: "09:00" },
  { start: "09:00", end: "10:00" },
  { start: "10:00", end: "11:00" },
  { start: "11:00", end: "12:00" },
  { start: "12:00", end: "13:00" },
  { start: "13:00", end: "14:00" },
  { start: "14:00", end: "15:00" },
  { start: "15:00", end: "16:00" },
  { start: "16:00", end: "17:00" },
  { start: "17:00", end: "18:00" },
];

// public enum OrderType {
//   [Description("سفارش جدید")]
//     NewOrder = 1,

//   [Description("اصلاحیه")]
//     Repair = 2,

//   [Description("تجدید ساخت")]
//     RebuildOrder = 3,

//   [Description("خرابی")]
//     Failure = 4,

//   [Description("تست")]
//     Test = 5,

//   [Description("تخفیف دار")]
//     Discounted = 6,

//   [Description("فقط طراحی")]
//     JustDesign = 7,

//   [Description("فقط مونتاژ")]
//     JustAssemble = 8,
// }

// const orderTypesColor = [
//   // جدبد-تست-مونتاز-فقط-فقط طراحی-تخفیف دار
//   {
//     type: 1,
//     color: '#03A9F4'
//   },
//   {
//     type: 5,
//     color: '#03A9F4'
//   },
//   {
//     type: 8,
//     color: '#03A9F4'
//   }
//   ,
//   {
//     type: 7,
//     color: '#03A9F4'
//   }
//   ,
//   {
//     type: 6,
//     color: '#03A9F4'
//   }
//    ,






//   //  خرابی
//   {
//     type: 4,
//     color: '#8E16D4'
//   }
//   // اصلاحیه



//   ,
//   {
//     type: 2,
//     color: '#FF9800'
//   }
//   // تجدید ساخت
//    ,
//   {
//     type: 3,
//     color: '#4CAF50'
//   }
// ]

 const orderTypesColor = {
    1: '#03A9F4',
    5: '#03A9F4',
    8: '#03A9F4',
    7: '#03A9F4',
    6: '#03A9F4',
    4: '#8E16D4',
    2: '#FF9800',
    3: '#4CAF50'
}









  //   2: <ErrorOutlineOutlinedIcon color="warning" fontSize="small" />,
  //   4: <Contradiction />,
  // };

export {
  initialBody,
  designerHistorylCol,
  addInitialValues,
  performanceInitialBody,
  orderTypesColor
}
